"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var react_router_dom_1 = require("react-router-dom");
var react_2 = require("@fluentui/react");
require("./CheckAuthentication.scss");
var action_1 = require("../Redux/action");
var mapDispatchToProps = {
    dispachStoreAuthenticatedUser: action_1.storeAuthenticatedUserAction
};
var connector = react_redux_1.connect(undefined, mapDispatchToProps);
var CheckAuthentication = function (props) {
    var _a = react_1.useState(false), isAuth = _a[0], setIsAuth = _a[1];
    var _b = react_1.useState(''), error = _b[0], setError = _b[1];
    var location = react_router_dom_1.useLocation();
    var authService = props.authService, applicationLogo = props.applicationLogo, applicationName = props.applicationName, children = props.children, dispachStoreAuthenticatedUser = props.dispachStoreAuthenticatedUser;
    function isOidcPath(pathname) {
        if (pathname) {
            return (pathname.startsWith('/login') ||
                pathname.startsWith('/logout') ||
                pathname.startsWith('/silentLogin'));
        }
        return (null);
    }
    if (!isOidcPath(location.pathname)) {
        if (authService) {
            authService
                .ensureLogin(location.pathname + location.search)
                .then(function (authenticated) {
                var _a;
                if (authenticated) {
                    dispachStoreAuthenticatedUser((_a = authService.currentUser) !== null && _a !== void 0 ? _a : undefined);
                    setIsAuth(true);
                }
            })
                .catch(function (exception) {
                dispachStoreAuthenticatedUser(undefined);
                setError(exception.message);
            });
        }
    }
    else if (!isAuth) {
        setIsAuth(true);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isAuth && children,
        error !== '' && (react_1.default.createElement("div", { className: "checkAuthentification" },
            react_1.default.createElement("img", { src: applicationLogo, alt: "Application logo" }),
            react_1.default.createElement("h1", null, applicationName),
            react_1.default.createElement(react_2.Icon, { iconName: "DisconnectVirtualMachine" }),
            react_1.default.createElement("h2", null,
                "A network error has occured.",
                react_1.default.createElement("br", null),
                "Check your VPN."),
            react_1.default.createElement("a", { href: (authService === null || authService === void 0 ? void 0 : authService.userManager.settings.authority) + ".well-known/openid-configuration", target: "_blank", rel: "noopener noreferrer" }, "Refresh")))));
};
exports.default = connector(CheckAuthentication);
//# sourceMappingURL=CheckAuthentication.js.map